import '@babel/polyfill'
import Vue from 'vue'
import './plugins/vuetify'
import Vuelidate from 'vuelidate';
import VueResource from 'vue-resource'
import App from './App.vue'
import router from './router'
import moment from 'moment-timezone';
import Croppa from 'vue-croppa';
import "vue-swatches/dist/vue-swatches.min.css"
import 'vue-croppa/dist/vue-croppa.css';
import { i18n } from './utils/locales/default';
import routeAuth from './router/routeAuth';

Vue.config.productionTip = false
Vue.use(Vuelidate)
Vue.use(VueResource)
Vue.use(Croppa);

Vue.http.options.root = process.env.VUE_APP_ROOT_API || 'http://localhost:9090/api';

Vue.http.interceptors.push((request, next) => {
  const token = localStorage.getItem("userToken")
  if (token) {
    request.headers.set('Authorization', 'Bearer ' + token);
  }

  next((response) => {
    if (router.currentRoute.name === 'login') return;
    if (response.status === 403) {
      events.$emit('closeSession');
    } else if (response.status === 401) {
      events.$emit('closeSession', router.currentRoute.path);
    }
  });
});

export const headers = Vue.http.headers.common;

export const events = new Vue();

events.$on('closeSession', (fullPath) => {
  
  localStorage.removeItem('userId');
  localStorage.removeItem('userToken');
  localStorage.removeItem('userCredentials');
  if(fullPath){
    router.push({ path: '/login', query: { redirect: fullPath } });
  }else{
    router.push('/login');
  }
})

routeAuth.setEvents(events);
routeAuth.applyRules(router);

export const printList = function (headers, list, document, window) {
  let popupWin;
  let sheets = document.styleSheets;
  var stylesNodes = [];
  for (var c = 0; c < sheets.length; c++) {
    stylesNodes.push(sheets.item(c).ownerNode);
  }
  popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
  var htmlNode = popupWin.document.childNodes.item(0);
  var headNode = htmlNode.childNodes.item(0);
  var bodyNode = htmlNode.childNodes.item(1);
  stylesNodes.forEach(styleNode => {
    headNode.appendChild(styleNode.cloneNode(true));
  })
  //Table
  var displayTable = document.querySelector("table");
  var tableNode = popupWin.document.createElement("table");
  tableNode.setAttribute("class", displayTable.className);
  bodyNode.appendChild(tableNode);
  //Thead
  var displayTh = displayTable.querySelector("th");
  var theadNode = popupWin.document.createElement("thead");
  tableNode.appendChild(theadNode);
  var headerNode = popupWin.document.createElement("tr");
  theadNode.appendChild(headerNode);
  headers.forEach(header => {
    var thNode = popupWin.document.createElement("th");
    thNode.setAttribute("class", displayTh.className);
    thNode.textContent = header.display;
    headerNode.appendChild(thNode);
  });
  //Tbody
  var displayTd = displayTable.querySelector("td");
  var tbodyNode = popupWin.document.createElement("tbody");
  tableNode.appendChild(tbodyNode);
  list.forEach(row => {
    var trNode = popupWin.document.createElement("tr");
    tbodyNode.appendChild(trNode);
    headers.forEach(header => {
      var tdNode = popupWin.document.createElement("td");
      tdNode.setAttribute("class", displayTd.className);
      switch (header.type) {
        case "date":
          tdNode.textContent = moment(row[header]).locale("es").format('LL')
          break;
        case "boolean":
          tdNode.textContent = row[header] ? "Sí" : "No";
          break;
        case "icon":
          var iNode = popupWin.document.createElement("i");
          iNode.setAttribute("class", "v-icon material-icons theme--light secondary--text");
          iNode.textContent = row[header.name];
          tdNode.appendChild(iNode);
          break;
        case "object":
          var property;
          header.name.split(".").forEach(key => {
            if (property) {
              property = property[key]
            } else {
              property = row[key];
            }
          });
          tdNode.textContent = property;
          break;
        case "array":
          var text = "";
          var keys = header.name.split(".");
          row[keys[0]].forEach(x => {
            text += x[keys[1]] + " "
          });
          tdNode.textContent = text;
          break;
        default:
          tdNode.textContent = row[header.name];
      }
      trNode.appendChild(tdNode);
    });
  });
  setTimeout(function () {
    popupWin.print();
    popupWin.close();
  }, 0);
}

new Vue({
  i18n,
  router,
  render: h => h(App)
}).$mount('#app')
